import { useCookies } from 'react-cookie'
import { useLocation } from 'react-use'

import { useEffect } from 'react'
import createPersonalizationClient from '../clients/personalization'

const cookieNames = {
  MBOX_RESPONSES: 'mboxResponses'
}
const path = '/'
const domain = '.telus.com'

const setPersonalizationCookies = (contentfulResponse, setCookie) => {
  const { mboxResponses } = contentfulResponse

  if (mboxResponses) {
    setCookie(cookieNames.MBOX_RESPONSES, JSON.stringify(mboxResponses), { domain, path })
  }
}

/**
 * Creates a cookie value for A/B test reporting purposes.
 * activityId: The ID of the A/B test activity (i.e. feature flag name).
 * experienceName: The name of the experience variant.
 */
const createABTestCookie = (activityId, experienceName) => {
  return JSON.stringify([{ activityId, experienceName }])
}

const useAbTesting = () => {
  const location = useLocation()
  const [cookies, setCookie] = useCookies()

  useEffect(() => {
    // unified-commerce-checkout will set an "exp" query parameter on redirect for the
    // "show-cart-before-checkout-mfe" A/B test.
    const params = new URLSearchParams(location.search)
    const experienceName = params.get('exp')
    if (experienceName) {
      setCookie(
        cookieNames.MBOX_RESPONSES,
        createABTestCookie('show-cart-before-checkout-mfe', experienceName),
        { path }
      )
    }
  }, [])

  const personalizationClient = createPersonalizationClient(cookies)
  const trigger = async (activityContainerId, check) => {
    const { fields } = await personalizationClient.getEntry(activityContainerId)
    setPersonalizationCookies(fields, setCookie)
    if (typeof check === 'function') {
      return check(fields, cookies)
    }
    return fields
  }

  return trigger
}

export default useAbTesting
